module.exports = __webpack_public_path__ + "static/media/ios-alert.80af9b4a.svg";